import {
  AgeGroup,
  MachinePublicHydrated,
} from "@aura-frontend/omnibus-az-client";
import { ListOption } from "@win-reality/react-ui";

export type DeviceHealth = "healthy" | "error";

const ageGroupEnum = [
  "8U",
  "9U",
  "10U",
  "11U",
  "12U",
  "13U",
  "14U",
  "15U",
  "16U",
  "17U",
  "18U",
  "College",
  "Pro",
] as const satisfies readonly AgeGroup[];

export const ageGroupOptions: ListOption<AgeGroup>[] = ageGroupEnum.map(
  (ageGroup) => ({
    value: ageGroup,
    label: ageGroup,
  }),
);

/** A lineup or substitution entry, as omnibus stores it (LineupEntrySC). */
export type GameLineupPlayer = {
  player_name?: string;
  external_id?: string;
  hit_side?: string | null;
  pitch_side?: string | null;
  jersey_number?: number | null;
};

export type GameSC = {
  game_uuid: string;
  generated_display_name: string;
  displayName?: string;
  type: string;
  sport: string;
  machine_uuid: string;
  year_month: string;
  times?: Array<{ start_time: number; machine_uuid: string }>;
  teams?: {
    home?: string;
    away?: string;
  };
  lineups?: {
    home_lineup?: Array<GameLineupPlayer & { position?: string }>;
    away_lineup?: Array<GameLineupPlayer & { position?: string }>;
  };
  substitutions?: Array<{
    previous_lineup_player?: GameLineupPlayer;
    new_lineup_player?: GameLineupPlayer;
  }>;
};

export type Device = {
  id: string;
  name: string;
  health: DeviceHealth;
  enabled: boolean;
  description?: string;
  type: "stat_tracker" | "umpire_assist";
};

const batHandEnum = ["R", "L", "S"] as const;
type batHand = (typeof batHandEnum)[number];
export const playerHandOptions: ListOption<batHand>[] = batHandEnum.map(
  (hand) => ({ value: hand, label: hand }),
);

export type GamePlayer = {
  uuid: string;
  firstName: string;
  lastName: string;
  birthdate: string;
  jerseyNumber: string;
  batHand: batHand;
  throwHand: batHand;
};

export type GameTeam = {
  name: string;
  uuid: string;
  parentName?: string | null;
  players: GamePlayer[];
  currentLineup: GamePlayer[];
  currentPitcher: GamePlayer | null;
  currentCatcher: GamePlayer | null;
};

export type StrikeZoneConfig = {
  averageHitterHeight: number;
  extendedHorizontalZone: number;
  extendedVerticalZone: number;
  strikeZoneIntercept: number;
};

export type FieldDimensions = {
  baseDistance: number;
  leftFieldDistance: number;
  centerFieldDistance: number;
  rightFieldDistance: number;
};

export type GameScoring = {
  source: "customer";
  name: string;
  email: string;
};

export type FieldEventSource = "playbook365" | "upper-hand";

export type Complex = {
  name: string;
  location: string;
  imageUrl?: string;
  fields: MachinePublicHydrated[];
  activeEventsCount: number;
  scheduledEventsCount: number | undefined;
  fieldCount: number;
};
